import React, { useEffect, useState } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';
import { List } from 'immutable';
import { schema } from '../../../../../state/schema';
import store from '../../../../../state/store';
import { denormalize } from 'normalizr';

const { Option } = Select;

const CareGuidesMembersPartnership = ({
  form,
  name,
  label,
  isLoading,
  disabled,
  load,
  onChange,
  rules = null,
  style = null,
  loadOnMount = true,
  emptyOption = false,
  multiple = false,
  filter = {},
  total,
  partnershipId,
  ...props
}) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);

  const [result, setResult] = useState(List([]));

  const limit = 10;
  const state = store.getState();

  // load sections on mount
  useEffect(() => {
    if (loadOnMount) {
      load(partnershipId, page, limit, (success, result) => {
        if (success) {
          setResult(List(result));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, page, limit, loadOnMount]);

  const onScroll = async (event) => {
    const target = event.target;
    if (
      !isLoading &&
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      total > data.length
    ) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    const options = result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['careGuidesMembersPartnership', x]),
                schema.careGuideMemberPartnership,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [];
    setData((prevState) => {
      const filteredOptions = options.filter(
        (newOption) => !prevState.some((x) => x.id === newOption.id)
      );
      return prevState.concat(filteredOptions);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  useEffect(() => {
    if (firstLoad) {
      const objectId = form.getFieldValue(name);
      if (objectId) {
        const object = objectId
          ? denormalize(
              state.entities.getIn(['careGuidesMembersPartnership', objectId]),
              schema.careGuideMemberPartnership,
              state.entities.toJS()
            )
          : null;

        setData((prevState) => {
          let existObject = prevState.find((x) => x.id === object.id);
          if (!existObject) {
            prevState.push(object);
          }

          return prevState;
        });
        setFirstLoad(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstLoad]);

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item
            name={name}
            label={label ? label : t('care_guide_helper_members')}
            rules={rules}
          >
            <Select
              onPopupScroll={onScroll}
              optionFilterProp='children'
              disabled={disabled}
              loading={isLoading}
              mode={multiple ? 'multiple' : null}
            >
              {emptyOption ? (
                <Select.Option key='empty-option' value={null}>
                  {t('form_input_options_none')}
                </Select.Option>
              ) : null}

              {data.map((x) => (
                <Option key={x?.profile?.id} value={x?.profile?.id}>
                  {x?.profile?.first_name} {x?.profile?.last_name}
                </Option>
              ))}
              {isLoading && (
                <Select.Option disabled key={-1}>
                  {t('form_input_loading')}
                </Select.Option>
              )}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default CareGuidesMembersPartnership;
